import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import jwtDecode from 'jwt-decode';
import { RootState, RootDispatch } from 'storage/store';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material';
import Grid from '@mui/material/Grid2';
import theme from 'App.theme';
import { Alert } from 'components/Alert';
import { Button } from 'components/Button';

interface IDecodedToken {
  sub: string;
  impersonator: string;
  callbackurl: string;
}

const Container = styled('div')`
  margin: 10px;
  position: relative;
  top: 100px;
`;

const Impersonation = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<RootDispatch>();
  const user = useSelector((state: RootState) => state.user);
  const token = localStorage.getItem('token');
  if (!token) {
    return null;
  }
  const decodedToken: IDecodedToken = jwtDecode(token);
  if (!decodedToken.impersonator || !decodedToken.callbackurl) {
    return null;
  }

  useEffect(() => {
    if (decodedToken) {
      dispatch.user.setImpersonation(true);
    }
  }, [token]);

  const { href } = window.location;
  const prodDomain = 'best.com.pl';
  const isProd = href.includes(prodDomain);

  const backToPanelClickHandle = () => {
    dispatch.user.setImpersonation(false);
    dispatch.user.logoutUser();
    window.location.replace(decodedToken.callbackurl);
  };

  return (
    <Container>
      <Alert
        variant="standard"
        severity={isProd ? 'error' : 'success'}
        title={t('IMPERSONATION_TITLE')}
      >
        <Grid container>
          <Grid size={12}>
            <p>
              {t('IMPERSONATION_LOGGEDAS')}:{' '}
              <b>
                {user?.firstName} {user?.lastName}
              </b>{' '}
              <b>{user?.email}</b>
            </p>
            <p>
              {t('IMPERSONATION_LOGGEDBY')}:<b> {decodedToken.impersonator}</b>
              {isProd ? (
                <span style={{ color: theme.palette.error.main }}>
                  <b> | {t('IMPERSONATION_PRODMESSAGE')}</b>
                </span>
              ) : null}
            </p>
          </Grid>
          <Grid size={6}>
            <Button onClick={backToPanelClickHandle} type="button">
              {t('IMPERSONATION_BACKTOPANEL')}
            </Button>
          </Grid>
        </Grid>
      </Alert>
    </Container>
  );
};

export default Impersonation;
